import { API_ROOT } from '../config'

// Tells the API the customer is leaving for the payment gateway (Redsys / Addon),
// so the prerental gets the longer hold before the automatic cancel. Called from
// the payment form's submit: sendBeacon survives the page navigating away, and a
// bodyless text/plain POST needs no CORS preflight. Never blocks the payment.
export function markPaymentStarted(prerentCode) {
  if (!prerentCode) return
  const url = `${API_ROOT}qrs/payment-started/${encodeURIComponent(prerentCode)}`
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(url)) return
  } catch (e) {
    // fall back to fetch below
  }
  try {
    fetch(url, { method: 'POST', keepalive: true }).catch(() => {})
  } catch (e) {
    // ignore: the payment must go on regardless
  }
}
